import './LessonsInfo.css';
import Lessons1 from '../../PageAssets/Photos/Lessons1.jpg'
import Lessons2 from '../../PageAssets/Photos/Lessons2.jpg'
import Lessons3 from '../../PageAssets/Photos/Lessons3.jpg'


const LessonsInfo = () => {


    return (
        <div id='LessonsInfoMainContainer'>

            <p className='LessonsInfoParagrafs'>Zajecia odbywaja się na obiektach AWFiS</p>
             <p className='LessonsInfoParagrafs'>w Gdańsku przy ul.Kazimierza Górskiego 1</p>
              <p className='LessonsInfoParagrafs'>W sezonie zimowym na krytej bieżni Lekko Atletycznej</p>
               <p className='LessonsInfoParagrafs'>Natomiast w sezonie letnim gdy pogoda na to pozwala na pobliskim stadionie</p>
 
            <div className='LessonsInfoPhotosMainContainer'>
              <img src={Lessons3} alt="Opis zdjęcia" className='LessonsInfoPhotos' />
               <img src={Lessons2} alt="Opis zdjęcia" className='LessonsInfoPhotos' />
                <img src={Lessons1} alt="Opis zdjęcia" className='LessonsInfoPhotos' />
            </div>
          
        </div>
    )
}

export default LessonsInfo;